import { useReporting } from '@/hooks/useReporting';
import { ProviderType } from '@/reporting/types';
import logger from '@/utils/client-logger';
import { useCallback } from 'react';

/**
 * 首页第三方埋点Hook
 * 对应Vue版本中index.vue的第三方埋点功能
 */
export function useHomeThirdPartyTracking() {
  const { trackEvent } = useReporting();

  /**
   * Criteo埋点：首页浏览
   * 对应Vue版本中activated()和mounted()的criteo埋点
   */
  const trackCriteoViewHome = useCallback(() => {
    try {
      trackEvent(
        {
          eventName: 'viewHome',
          properties: {},
        },
        [ProviderType.CRITEO],
      );

      logger.log('🔍 Criteo埋点 - viewHome');
    } catch (error) {
      logger.error('Criteo viewHome tracking error:', error);
    }
  }, [trackEvent]);

  /**
   * Bing (Uetq)埋点：首页浏览
   * 对应Vue版本中mounted()的bing埋点
   */
  const trackBingHomePage = useCallback(() => {
    try {
      trackEvent(
        {
          eventName: '',
          properties: {
            ecomm_pagetype: 'home',
          },
        },
        [ProviderType.BING],
      );
      // TODO: 临时放这里吧，后续这些页面的埋点都需要统一集中处理一次，现在散落各地
      trackEvent(
        {
          eventName: 'home',
        },
        [ProviderType.RTB_HOUSE],
      );

      logger.log('🔍 Bing埋点 - 首页浏览');
    } catch (error) {
      logger.error('Bing home page tracking error:', error);
    }
  }, [trackEvent]);

  /**
   * 初始化首页第三方埋点
   * 对应Vue版本中mounted()的第三方埋点逻辑
   */
  const initHomeThirdPartyTracking = useCallback(() => {
    try {
      // Bing埋点
      trackBingHomePage();

      // Criteo埋点
      trackCriteoViewHome();

      logger.log('🔍 首页第三方埋点初始化完成');
    } catch (error) {
      logger.error('首页第三方埋点初始化失败:', error);
    }
  }, [trackBingHomePage, trackCriteoViewHome]);

  return {
    trackCriteoViewHome,
    trackBingHomePage,
    initHomeThirdPartyTracking,
  };
}
